import {AccordionV2 as PeacockAccordion} from '@pepsico-ds/ui'

/**
 * @typedef {import('@pepsico-ds/ui').IAccordionV2Props} AccordionProps
 */

/**
 * Wrapper around Peacock DS AccordionV2.
 * Supports all Peacock DS accordion props.
 * @param {AccordionProps} props
 */
export const Accordion = props => {
  return <PeacockAccordion {...props} />
}
